import { render, staticRenderFns } from "./AddDriver.vue?vue&type=template&id=0cf45d74&"
import script from "./AddDriver.vue?vue&type=script&lang=js&"
export * from "./AddDriver.vue?vue&type=script&lang=js&"
import style0 from "./AddDriver.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports